export const isDefaultParams = (defaultParams = {}) => Boolean(Object.values(defaultParams).filter((_) => _).length);
//# sourceMappingURL=isDefaultParams.js.map